import { initPageArticle } from '@/pages-article/init'

initPageArticle()
